import { useToast } from '@televet/kibble-ui/build/components/Toast';

interface UseClipboardOutput {
  copy: (text: string) => void;
}

export const useClipboard = (): UseClipboardOutput => {
  const toast = useToast();

  const copy = (text: string): void => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast({
          status: 'success',
          title: 'Copied to clipboard',
        });
      })
      .catch(() => {
        toast({
          status: 'error',
          title: 'Error copying to clipboard',
        });
      });
  };

  return { copy };
};
